import { useMutation } from "@apollo/react-hooks";
import { useAsyncCallback } from 'react-use-async-callback';
import gql from "graphql-tag";
import { AsyncActionStatus } from '../../../shared/abstractStore';
import { QuestionnaireSectionUpdateInput } from '../generated/globalTypes';
import { updateQuestionnaireSectionMutation, updateQuestionnaireSectionMutationVariables } from '../generated/updateQuestionnaireSectionMutation';
import { questionnaireSectionFieldsFragment } from '../models/QuestionnaireSection';

/**
 * Get a callback to update a QuestionnaireSection in the store.
 */
export function useUpdateQuestionnaireSectionCallback(): [(id: string, model: QuestionnaireSectionUpdateInput) => Promise<void>, AsyncActionStatus] {
    const [mutationAction, { error }] = useMutation<updateQuestionnaireSectionMutation, updateQuestionnaireSectionMutationVariables>(
        gql`
            mutation updateQuestionnaireSectionMutation ($model: QuestionnaireSectionUpdateInput!) {
                updateQuestionnaireSection(model: $model) {
                    ...questionnaireSectionFields
                }
            }

            ${questionnaireSectionFieldsFragment}
        `
    );

    // Wrap the mutation in a standard callback.
    const [action, { isExecuting, errors: actionErrors }] = useAsyncCallback(async (id: string, model: QuestionnaireSectionUpdateInput) => {
        const result = await mutationAction({ variables: { model: { ...model, id: id } } });
        if (result.errors && result.errors.length) {
            throw result.errors;
        }
    }, [mutationAction]);

    return [action, { isExecuting: isExecuting, errors: error ? error.message : actionErrors }];
}
